const StatCard = ({ count, label, sublabel }) => {
  return (
    <div className="bg-green text-white p-6 rounded-3xl text-center">
      <div
        className={`md:text-4xl sm:text-3xl text-2xl mb-4 ${
          label === "Tilbage" ? "text-[#FFB4AB]" : "text-[#03A067]"
        }`}
      >
        {count}
      </div>
      <div className="md:text-3xl sm:text-2xl text-xl font-bold mb-2">
        {label}
      </div>
      <div className="md:text-lg sm:text-md text-sm opacity-80">{sublabel}</div>
    </div>
  );
};

const Stats = ({ schedule }) => {
  let pending = [];
  let complete = [];
  if (schedule && schedule.length > 0) {
    schedule.filter((val) => {
      if (+val.sched_status === 0) {
        pending.push(val);
      } else {
        complete.push(val);
      }
    });
  }
  return (
    <div className="grid grid-cols-2 gap-4">
      <StatCard
        count={complete.length}
        label="Afsluttet"
        sublabel="Aktiviteter"
      />
      <StatCard
        count={pending.length}
        label="Tilbage"
        sublabel="Aktiviteter"
      />
    </div>
  );
};

export default Stats;
